// frontend/admin-portal/src/components/dashboard/LowStockList.jsx
import React from "react";
import { Alert, Spinner, Badge, Button, Panel } from "@fiberhome/shared-ui";
import { useNavigate } from "react-router-dom";

export default function LowStockList({ slice }) {
  const navigate = useNavigate();
  const { data, loading, error } = slice;

  return (
    <Panel
      title="Low Stock"
      subtitle="Products at or below minimum"
      tone="warning"
      actions={
        <Button variant="ghost" size="sm" onClick={() => navigate("/products")}>
          View products →
        </Button>
      }
    >
      {loading && (
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <Spinner size="sm" />
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}
      {!loading && !error && data.length === 0 && (
        <div className="fh-dashboard-empty">
          Nothing is running low. All good 👍
        </div>
      )}
      {!loading && !error && data.length > 0 && (
        <ul className="fh-dash-list">
          {data.map((p) => (
            <li
              key={p.id}
              className="fh-dash-list__item"
              onClick={() => navigate(`/products/${p.id}`)}
            >
              <div style={{ minWidth: 0 }}>
                <div className="fh-dash-list__title">{p.name}</div>
                <div className="fh-dash-list__sub">
                  {p.sku} · min {p.minStock} {p.unit}
                </div>
              </div>
              <Badge variant={p.stock <= 0 ? "danger" : "warning"}>
                {p.stock} {p.unit}
              </Badge>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
}
